var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Floating Button - Exit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7596 18.3701L24.2164 24.8276L25.0227 25.6339L26.6352 24.0213L25.8289 23.2149L19.3721 16.7574L18.5658 15.9511L16.9534 17.5637L17.7596 18.3701Z",
    fill: "#0A313F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 2_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3721 24.8203L25.8287 18.363L26.635 17.5567L25.0224 15.944L24.2162 16.7503L17.7596 23.2076L16.9534 24.0139L18.5659 25.6266L19.3721 24.8203Z",
    fill: "#0A313F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.9e23fdcdd8a781a62907fe622af195e4.svg";
export { ForwardRef as ReactComponent };